<template>
  <div class="tw-w-full">
    <iframe 
      ref="iframe" 
      :srcdoc="content" 
      width="100%" 
      @load="onLoad"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    widget: { type: String, required: true }
  },
  computed: {
    iframe() {
      return this.$refs.iframe as HTMLIFrameElement;
    },
    content(): string {
      return '<!DOCTYPE html><head></head><body>' + this.widget + '</body></html>';
    }
  },
  mounted() {
    window.addEventListener('message', this.onAnswer);
  },
  beforeUnmount() {
    window.removeEventListener('message', this.onAnswer);
  },
  methods: {
    onLoad() {
      this.$nextTick(this.autoSize);
      
    },
    autoSize() {
      if(!this.iframe?.contentWindow) {
        return;
      }
      const body = this.iframe.contentWindow.document.body;
      if (body) {
        this.iframe.style.height = body.scrollHeight + 'px';
      }
    },
    onAnswer(event: MessageEvent) {
      if(event.data.type == 'WIDGET_ANSWER') {
        this.$emit('answer', event.data.data);
      }
    }
  }
});
</script>